import React from "react";
import { LoaderSvg } from "../../assets/svg";

const ButtonLoader = ({ removeTheme }) => {
  return (
    <button
      className={`p-0 flex items-center text-center justify-center rounded uppercase w-full ${
        removeTheme ? "text-themeBtn" : "text-white"
      } `}
    >
      <LoaderSvg />
      <span>Loading...</span>
    </button>
  );
};

export default ButtonLoader;
